<div class="search-container">
	<div class="location">
	
		<form style="width:100%;">			
			<div class="nsw-form__group" style="width:100%;">
				<label class="nsw-form__label" for="search-input">Find a monitored swim site by name, suburb, location or region</label>            
				<div class="nsw-form__input-group nsw-form__input-group--icon">
					<label class="sr-only label-text" for="search-input">Search</label>
					<input  type="text" id="search-input" #searchInput style="width:100%;"
						class="nsw-form__input  js-search-input"
						name="search-input" 
						aria-label="Find a monitored swim site by suburb, location or region"
						(keyup)="onSearchKeyUp($event)" 
						[matAutocomplete]="searchAuto"
						[formControl]="searchFormControl"
						placeholder="Search" />						
					<button class="nsw-button nsw-button--white nsw-button--flex" type="button" 
						aria-expanded="false" aria-controls="header-search"
						(click)="executeSearch()" aria-label="Search">
						<span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true" 
							alt="Find a monitored swim site by suburb, location or region">search</span>
						<span class="sr-only">Search</span>							
					</button>
					<ul class="nsw-form__predictive-list">
						<mat-autocomplete 
							#searchAuto="matAutocomplete" autoActiveFirstOption="true" 
							(optionSelected)="onOptionSelected($event)"
							[displayWith]="getOptionDisplayName">									
							<mat-optgroup *ngFor="let group of searchOptionGroups | async" 										
								[label]="group.name | titlecase">
								<mat-option *ngFor="let option of group.options" 
									[id]="getOptionId(option)" 																						
									[value]="option">
									{{getOptionDisplayName(option) | titlecase}}
								</mat-option>
							</mat-optgroup>
						</mat-autocomplete>
					</ul>
					
				</div>
			</div>
		</form>
		<a 
			class="nsw-link nsw-link--icon" 			
			[tabindex]="0" 
			href="javascript:void(0)"
			(click)="onZoomToCurrentLocationClicked()">
			<img src="assets/images/home/location.svg" alt="current-location">
			<span style="padding:10px;">Use my current location</span>				
		</a>			
	</div>	
</div>
